module.exports = __webpack_public_path__ + "img/partfour_pic2.ad09cef2.png";